import React from "react";
import { MailCheck } from "lucide-react";

export default function VerifyEmailNotice({ email, onResend, resending, resent }) {
  return (
    <div className="p-4 border border-brand/30 bg-brand/5 rounded-sm space-y-2" data-testid="verify-email-notice">
      <div className="flex items-start gap-3">
        <MailCheck className="w-5 h-5 text-brand shrink-0 mt-0.5" />
        <div className="text-sm text-ink">
          We've sent a verification link to <b>{email}</b>. Click it, then come back and sign in.
          <div className="text-[12px] text-ink-muted mt-1">Can't find it? Check your spam folder.</div>
        </div>
      </div>
      {onResend && (
        <button type="button" onClick={onResend} disabled={resending || resent} data-testid="resend-verification-btn" className="text-[13px] text-brand hover:underline disabled:opacity-60 disabled:no-underline ml-8">
          {resent ? "Verification email sent" : resending ? "Sending…" : "Resend verification email"}
        </button>
      )}
    </div>
  );
}
